import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBarsFilter } from '@fortawesome/pro-regular-svg-icons';

interface FilterLabelRowProps {
  /** Omit for Partner roles — a single-org caller has no "which partner" to show. */
  orgLabel?: string;
  companyLabel: string;
  dateLabel: string;
}

/**
 * Shared "🔽 Org · Company · Date" filter-summary row used by dashboard
 * card headers. The bars-filter icon always leads whichever segment ends up
 * first — org is commonly omitted for Partner roles (single-org callers
 * have no "which partner" to show), in which case the row collapses
 * straight to Company (or Date) instead of leaving a stray separator behind.
 */
const FilterLabelRow: React.FC<FilterLabelRowProps> = ({ orgLabel, companyLabel, dateLabel }) => {
  const segments = [orgLabel, companyLabel, dateLabel].filter((s): s is string => Boolean(s));

  return (
    <>
      {segments.map((segment, i) => (
        <span className="suc-filter-item" key={`${i}-${segment}`}>
          {i === 0 ? (
            <FontAwesomeIcon icon={faBarsFilter} className="suc-filter-icon" />
          ) : (
            <span className="suc-filter-dot">•</span>
          )}
          {segment}
        </span>
      ))}
    </>
  );
};

export default FilterLabelRow;
